// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const createEvent = (productId, label, revenueValue) => ({
  ecomm_prodid: `${productId}`,
  ecomm_pagetype: 'purchase',
  event_label: label || '',
  revenue_value: revenueValue || 0,
  currency: 'USD',
});

export const sendBingEvent = (productId, label, revenueValue) => {
  const bingAdsId =
    window.ReactAppEnv &&
    window.ReactAppEnv.stats &&
    window.ReactAppEnv.stats.bingAdsId;

  if (bingAdsId) {
    if (!window.uetq) {
      /* eslint-disable no-unused-expressions, no-sequences, @typescript-eslint/no-unused-expressions */
      (function (w, d, t, r, u) {
        let f, n, i;
        (w[u] = w[u] || []),
          (f = function () {
            const o = { ti: bingAdsId };
            (o.q = w[u]), (w[u] = new window.UET(o));
            w[u].push('pageLoad');
          }),
          (n = d.createElement(t)),
          (n.src = r),
          (n.async = 1),
          (n.onload = n.onreadystatechange =
            function () {
              const s = this.readyState;
              (s && s !== 'loaded' && s !== 'complete') ||
                (f(), (n.onload = n.onreadystatechange = null));
            }),
          (i = d.getElementsByTagName(t)[0]),
          i.parentNode.insertBefore(n, i);
      })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
      /* eslint-enable no-unused-expressions, no-sequences, @typescript-eslint/no-unused-expressions */
    }
    const event = createEvent(productId, label, revenueValue);
    window.uetq?.push('event', 'product_purchase', event);
  }
};
